<template>
    <div class="dropdown"
         ref="refDropDown"
         :style = "data.styleDropDown"
    >
        <a class="toggle-list"
           href="#"
           @click.prevent="data.isOpen = !data.isOpen"
           :id="props.id"
        >
            {{  data.currentItem.value === "" ? i18n.t(props.defaultLabel) : data.currentItem.label[i18n.locale.value] }}

        </a>

        <simple-list
                :arrowHorizontalPosition="'left'"
                :arrowVerticalDirection="'up'"
                :isToggle="data.isOpen"
                :stylePos="data.styleListItem"
                :triggerId="props.id"
        >
            <a class="item"
               href="#"
               @click.prevent="selectItem({label:i18n.t(props.defaultLabel), value:''})"
            >
                {{ i18n.t(props.defaultLabel) }}
            </a>
            <a v-for="item in props.dataProvider"
               href="#"
               class="item"
               :class="isActive(item)"
               @click.prevent="selectItem(item)"
            >
                {{ item.label[i18n.locale.value] }}
            </a>
        </simple-list>



       <!-- <div class="item-list up"
             :style="data.styleListItem"
             ref="refItemList"
        >

        </div>-->

    </div>
</template>

<script>

    import {ref, reactive, onMounted, onUpdated, watchEffect, computed, nextTick,inject}  from "vue"
    import SimpleList from "@/views/lib/listing/SimpleList";

    const MARGIN_ITEM_LIST_TOP = 10; //margin between the selected label display and the item list

    export default {
        components:{
            SimpleList,
        },
        props: {
            dataProvider:Array,
            defaultLabel:String,
            dropdownWidth:String,
            dropdownHeight:String,
            listWidth:String,
            maxHeight:String,  //TODO: handle if any max height is set and set overflow scroll...
            id:String
        },
        setup(props, context) {

            const i18n = inject('i18n');
            const data = reactive({
                isOpen:false,
                currentItem:{label:i18n.t(props.defaultLabel), value:''},
                styleDropDown: {
                    width:props.dropdownWidth,
                    height:props.dropdownHeight
                },
                styleListItem: {
                    top: `${ parseInt(props.dropdownHeight) + MARGIN_ITEM_LIST_TOP}px`,
                    width: props.listWidth
                }
            })

            const refDropDown = ref(null);
            const refItemList = ref(null);

            const isActive = (item) => {
                return (item.value === data.currentItem.value) ? "active": "";
            }

            const selectItem = (item)=>{
                console.log('select item');
                data.isOpen = false;
                data.currentItem = item;
                //refItemList.value.style.display="none";
                context.emit("item-selected", item);

            }

            const setCurrentItem = (value) => {

                for (let item of props.dataProvider) {
                    if (item.value === value) {
                        data.currentItem = item;
                        break;
                    }
                }
            }

            return {
                i18n,
                data,
                props,
                refDropDown,
                refItemList,
                isActive,
                setCurrentItem,
                selectItem
            }
        }

    }
</script>

<style scoped lang="scss">

    .dropdown {
        color:#fff;
        position:relative;
        display: flex;
        align-items: center;
    }

    .toggle-list {
        width:100%;
        color:#fff;
        box-sizing: border-box;
        display:block;
        padding: 6px 30px 6px 6px;
        background: url("~images/icon_dropdown.png") right center no-repeat;
        background-size:18px 18px;
        position:relative;
    }

    a.item.active {
        background: $color-ui-active;

        &:after {
            content: "✔\fe0e";
            position: absolute;
            right: 10px;
        }
    }

</style>